import axios from '@/api/config';

const project = {
  getProjectById(data) {
    return axios.get(`${process.env.BASE_URL}/project/getProjectById/` + data, {});
  },
  getProjectDetail(data) {
    return axios.get(`${process.env.BASE_URL}/project/getProjectDetail`, {params: data});
  },
  getProject(data) {
    return axios.get(`${process.env.BASE_URL}/project/getProject`, {params: data});
  },
  getProjectPhaseList(data) {
    return axios.get(`${process.env.BASE_URL}/project/getProjectPhaseList`, {params: data});
  },
  getProjectList(data) {
    return axios.get(`${process.env.BASE_URL}/project/getProjectList`, {params: data});
  },
  getProjectTree(data) {
    return axios.get(`${process.env.BASE_URL}/project/getProjectTree`, {params: data});
  },
  pageList(data) {
    return axios.post(`${process.env.BASE_URL}/project/pageList`, data);
  },
  addProject(data) {
    return axios.post(`${process.env.BASE_URL}/project/addProject`, data);
  },
  updateProject(data) {
    return axios.put(`${process.env.BASE_URL}/project/updateProject`, data);
  },
  deleteProject(data) {
    return axios.delete(`${process.env.BASE_URL}/project/deleteProject`,  {data: data});
  },
  exportExcel(data) {
    return axios.get(`${process.env.BASE_URL}/project/exportExcel`, {params: data});
  },
  importData(data) {
    return axios.post(`${process.env.BASE_URL}/project/importData`, data);
  },
  active(data) {
    return axios.post(`${process.env.BASE_URL}/project/active`, data);
  },
}

export default project;



// WEBPACK FOOTER //
// ./src/api/project.js